import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { FullScreenLoader } from '../../components/Loader'
import { is } from '../../components/MediaQuery'
import PageTitle from '../../components/Template/PageTitle'
import useSize from '../../hooks/useSize'
import PageWrapper from '../../components/Template/PageWrapper'
import PageWidget from '../../components/Template/PageWidget'
import { Loader } from '../../components/Loader/CalendarLoader'
import { Prepayment } from '../../containers/Prepayment'
import {
  getPrepayments,
  getPrepaymentType,
} from '../../reducers/userObject/selectors/object'
import { useMixpanelTrackView } from '../../hooks/useMixpanelTrackView'

function PricePrepayment({ errMessage, isSaving, mobile }) {
  const isDesktop = is.desktop()
  const { t } = useTranslation()

  const size = useSize('profile')

  const type = useSelector(getPrepaymentType)
  const provision = useSelector(getPrepayments)
  useMixpanelTrackView('Prepayments Screen View')

  return (
    <Flex
      justifyStart={true}
      alignStart={true}
      column={true}
      style={{
        marginTop: mobile ? 0 : '1.5em',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <React.Suspense fallback={<FullScreenLoader />}>
        <PageWrapper>
          <PageWidget mobile={mobile} desktop={isDesktop}>
            <PageTitle size={size} desktop={isDesktop}>
              {t('BKO_902_menu_prepayment')}
            </PageTitle>

            {isSaving && errMessage === '' && <Loader />}
            {isSaving && errMessage !== '' && <p>{errMessage}</p>}
            {!isSaving && (
              <Prepayment
                key={JSON.stringify(provision)}
                userProvision={sortPrepayment(provision)}
                initialValues={{
                  prepayment_type: type,
                  provision: sortPrepayment(provision),
                }}
              />
            )}
          </PageWidget>
        </PageWrapper>
      </React.Suspense>
    </Flex>
  )
}

export default PricePrepayment

export interface IPricePrepaymentScreenProps {
  token: string
}

export function sortPrepayment(p, s = false) {
  const sorted = p
    ? p.sort((a, b) => {
        if (Number(a.days) === Number(b.days)) {
          return Number(b.percent) - Number(a.percent)
        }
        return s
          ? Number(b.days) - Number(a.days)
          : Number(a.days) - Number(b.days)
      })
    : []

  return sorted
}

export interface IPricePrepaymentScreenDispatch {
  loadData: () => void
}
